<template>
    <div v-click-outside="handleFocusOut">
        <b-form-input
            v-model="qs"
            :placeholder="placeholder"
            :disabled="disabled || !supplierId"
            @focus="showSuggestion = true"
            @keyup="search"
        />

        <div style="position: relative;" v-show="showSuggestion && suggestions.length > 0" tabindex="0">
            <div class="position-absolute w-100 zindex-1 cursor-pointer rounded-bottom border-left border-right border-bottom bg-white">
                <b-list-group flush>
                    <b-list-group-item
                        v-for="suggestion in suggestions"
                        :key="suggestion.id"
                        @click="pick(suggestion)"
                    >
                        <span>{{ suggestion.title }}</span>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>
    </div>
</template>

<script>
import {BFormInput, BListGroup, BListGroupItem} from 'bootstrap-vue'
import {ProductApi} from '@core/api'

function normalizeSuggestion(product) {
    if (!product || typeof product !== 'object') {
        return null
    }

    const productId = product.id || product.productId || null
    const code = product.identifier || product.code || ''
    const name = product.name || product.title || product.productName || product.label || ''

    if (!productId && !name) {
        return null
    }

    return {
        id: String(productId || name),
        productId: productId ? String(productId) : null,
        code: String(code || ''),
        name: String(name || ''),
        title: String(name || code || productId || ''),
        raw: product,
    }
}

export default {
    name: 'SupplierProductLookupSelect',
    components: {
        BFormInput,
        BListGroup,
        BListGroupItem,
    },
    directives: {
        'click-outside': {
            bind(el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event)
                    }
                }
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
        },
    },
    props: {
        supplierId: {
            type: [String, Number],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default() {
                return this.$t('Component(IncludedProduct):search-placeholder')
            },
        },
    },
    data() {
        return {
            qs: '',
            showSuggestion: false,
            suggestions: [],
            searchTimer: null,
        }
    },
    methods: {
        search() {
            if (!this.supplierId) {
                this.suggestions = []
                return
            }

            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
            }

            this.searchTimer = setTimeout(() => {
                if (!this.qs || this.qs.trim().length < 2) {
                    this.suggestions = []
                    return
                }

                ProductApi
                    .searchPurchasedProducts(this.supplierId, this.qs.trim())
                    .then((response) => {
                        const items = Array.isArray(response.data) ? response.data : []
                        this.suggestions = items
                            .map(normalizeSuggestion)
                            .filter(Boolean)
                    })
                    .catch(() => {
                        this.suggestions = []
                    })
            }, 400)
        },
        pick(suggestion) {
            this.qs = ''
            this.suggestions = []
            this.showSuggestion = false
            this.$emit('select', suggestion)
        },
        handleFocusOut() {
            this.showSuggestion = false
        },
    },
}
</script>
